export function parseOptions(str) {
  var options = {};
  try {
    options = JSON.parse(str);
  } catch (_a) {}
  return options;
}
;